import React from "react";
import styles from "@components/cancellationPoliciesPage/timelines/timeline.module.scss";
import clsx from "clsx";
import { FormattedMessage } from "react-intl";

const TimelineNonRefundable = () => (
  <div className={styles.timeline}>
    <div
      className={clsx(
        styles.timeline__amount,
        styles.timeline__amountRefundRed
      )}
      style={{ width: '100%' }}
    >
      <FormattedMessage id={`cancellation_policies.no_refund`} />
      <span className={styles.timeline__numberDays}>
        <FormattedMessage id={`cancellation_policies.up_to`} />:{' '}
        <strong>
          <FormattedMessage id={`contract_types.contract_start`} />
        </strong>
      </span>
    </div>
  </div>
);

export default TimelineNonRefundable;
